import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ICreateWishCampaignStepPayload {
    campaignId: string
    data: {
        subject: string
        content: string
        sendAt: Date
    }
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createWishStep = createSlice({
    name: 'campaign/create-wish-step',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<ICreateWishCampaignStepPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createWishStepActions = createWishStep.actions
export default createWishStep.reducer
